const PriceTable = (data) => {
  const table = document.createElement('table');
  const {
    academicLevels,
    deadlines,
  } = data;

  const th1 = document.createElement('th');
  const th2 = document.createElement('th');
  const tr = document.createElement('tr');

  table.classList.add('pricing-table');

  tr.classList.add('pricing-table__headers');

  th1.classList.add('pricing-table__deadline-header');
  th1.setAttribute('rowspan', '2');
  th1.innerText = 'Deadline';

  th2.classList.add('pricing-table__academic-levels-header');
  th2.setAttribute('colspan', '3');
  th2.innerText = 'Academic level';

  tr.appendChild(th1);
  tr.appendChild(th2);

  const tableLevelsRow = () => {
    const t = document.createElement('tr');
    t.classList.add('pricing-table__academic-levels-titles');

    academicLevels.forEach((level) => {
      const tableTd = document.createElement('td');
      tableTd.innerText = level.short_title;

      t.appendChild(tableTd);
    });

    return t;
  };

  const tableDeadlines = () => {
    const out = [];
    Object.entries(deadlines).forEach(([deadlineName, value], key) => {
      const t = document.createElement('tr');
      const th = document.createElement('th');
      th.classList.add('pricing-table__row__deadline-title');
      th.innerText = deadlineName;
      t.classList.add('pricing-table__row');
      t.classList.add(key % 2 ? 'pricing-table__row--odd' : 'pricing-table__row--even');
      t.appendChild(th);

      academicLevels.forEach((level) => {
        const tableTd = document.createElement('td');
        tableTd.setAttribute('data-deadline-id', level.id);
        if (academicLevels[0].id === level.id) tableTd.classList.add('deadline-active');
        tableTd.innerText = value[level.id] ? value[level.id].pricePerPage : 'n/a';

        t.appendChild(tableTd);
      });

      out.push(t);
    });

    return out;
  };

  table.appendChild(tr);
  table.appendChild(tableLevelsRow());
  [...tableDeadlines()].forEach((d) => table.appendChild(d));


  return new Promise((resolve, reject) => {
    if (data) resolve(table);
    reject(Error('Error data'));
  });
};

export default PriceTable;
